module.exports = {"greenTemperature":"그린 온도","hourlyGreenTemperature":"시간별 그린 온도","periodGreenTemperature":"기간별 그린 온도","selectGolfClubPlaceholder":"골프클럽을 선택하세요.","selectTypePlaceholder":"유형을 선택하세요.","lastUpdated":"최근 업데이트","refresh":"새로고침","noData":"데이터가 없습니다.","chartDateAxis":"날짜","chartTemperatureAxis":"온도"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/gr101.json
// module id = noC0
// module chunks = 2